import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import CoverImage from './CoverImage';
import { trackEvent } from '../services/analytics';
import '../styles/ExamEssentialsShelf.css';

function ExamEssentialsShelf() {
  const navigate = useNavigate();
  const [active, setActive] = useState(false);
  const [books, setBooks] = useState([]);

  useEffect(() => {
    let ignore = false;

    fetch('/api/insights/exam-mode')
      .then((response) => (response.ok ? response.json() : { active: false }))
      .then((data) => {
        if (ignore || !data.active) {
          return null;
        }
        setActive(true);
        trackEvent('exam_essentials_shelf_shown', { thisWeekCount: data.thisWeekCount });
        return fetch('/api/books/most-borrowed-this-month?limit=8')
          .then((response) => (response.ok ? response.json() : { books: [] }))
          .then((bookData) => {
            if (!ignore) {
              setBooks(Array.isArray(bookData.books) ? bookData.books : []);
            }
          });
      })
      .catch(() => {
        if (!ignore) {
          setActive(false);
        }
      });

    return () => {
      ignore = true;
    };
  }, []);

  const handleBookOpen = (book) => {
    trackEvent('exam_essentials_book_clicked', { biblioId: book.biblio_id });
    navigate(`/book/${book.biblio_id}`, { state: { from: 'home-browse' } });
  };

  if (!active || books.length === 0) {
    return null;
  }

  return (
    <section className="exam-shelf" aria-label="Exam essentials, trending now">
      <div className="exam-shelf__header">
        <h2 className="exam-shelf__title">Trending Now</h2>
        <p className="exam-shelf__subtitle">Search activity is up this week — here's what's getting borrowed most.</p>
      </div>
      <div className="exam-shelf__track">
        {books.map((book) => (
          <button
            type="button"
            key={book.biblio_id}
            className="exam-shelf__card"
            onClick={() => handleBookOpen(book)}
          >
            <CoverImage
              biblioId={book.biblio_id}
              isbn={book.isbn}
              alt={book.title}
              className="exam-shelf__cover"
              width={100}
              height={145}
              sizeCode="M"
            />
            <span className="exam-shelf__book-title">{book.title}</span>
            <span className="exam-shelf__borrow-count">{book.borrow_count} borrows this month</span>
          </button>
        ))}
      </div>
    </section>
  );
}

export default ExamEssentialsShelf;
